var map = {
	"./BR.png": "btX6",
	"./EN.png": "7iHK",
	"./IN.png": "RxQv",
	"./VN.png": "3tyT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "I1XW";


//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/.*\.png$
// module id = I1XW
// module chunks = 1